import React, { useState, useEffect } from "react";
import {
  PlusOutlined,
  CheckOutlined,
  CloseOutlined,
  WarningOutlined,
  CloseCircleFilled,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Button,
  theme,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Breadcrumb,
  Form,
  DatePicker,
  Popconfirm,
  message,
  Tooltip,
  Space,
} from "antd";
import menuItems from "../../../config/data/menus.json";
import { useNavigate } from "react-router-dom";
import BreadcrumbItem from "antd/es/breadcrumb/BreadcrumbItem";
import ContentTop from "../../../components/ContentTop";
import CustomButton from "../../../components/custom/CustomButton";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/MainLayout";
import { useForm } from "antd/lib/form/Form";
import customersData from "../../../config/data/dummy_data/customers.json";

const { Content } = Layout;
const { Text, Title } = Typography;
const Search = Input;

const AddSYA1300 = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKey, setSelectedKey] = useState("/sya1300");
  const [switchLabel, setSwitchLabel] = useState("Dark Mode");
  const [switchLabelColor, setSwitchLabelColor] = useState("#aeaeae");
  const [menuBG, setMenuBG] = useState("#2F172D");
  const [searchColorBgContainer, setSearchColorBgContainer] = useState("#3B2639");
  const [menuTheme, setMenuTheme] = useState("dark");
  const [leftLayoutMargin, setLeftLayoutMargin] = useState(190);
  const [logoDimensions, setLogoDimensions] = useState(100);
  const [menuSearchBarState, setMenuSearchBarState] = useState(false);
  const [menuSearchIconState, setMenuSearchIconState] = useState(true);
  const [switchLabelState, setSwitchLabelState] = useState(false);

  function onSwitchClick() {
    if (switchLabel === "Dark Mode") {
      setSwitchLabel("Light Mode");
      setMenuBG("#fff");
      setSearchColorBgContainer("#f7f8fa");
      setSwitchLabelColor("#8c8f9f");
      setMenuTheme("light");
    } else {
      setSwitchLabelColor("#aeaeae");
      setSwitchLabel("Dark Mode");
      setMenuBG("#2F172D");
      setSearchColorBgContainer("#3B2639");
      setMenuTheme("dark");
    }
  }

  function onMenuSelect(menuItems) {
    // console.log(menuItems.key);
    setSelectedKey(menuItems.key);
    navigate(menuItems.key, { replace: false });
  }

  useEffect(() => {
    if (collapsed === true) {
      setLeftLayoutMargin(71);
      setLogoDimensions(50);
      setMenuSearchBarState(true);
      setMenuSearchIconState(false);
      setSwitchLabelState(true);
    } else {
      setLeftLayoutMargin(190);
      setLogoDimensions(100);
      setMenuSearchBarState(false);
      setMenuSearchIconState(true);
      setSwitchLabelState(false);
    }
  });

  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            siderBg: menuBG,
          },
          Menu: {
            darkItemBg: menuBG,
            darkSubMenuItemBg: "#241223",
          },
        },
      }}
    >
      <MainLayout
        collapsed={collapsed}
        searchColorBgContainer={searchColorBgContainer}
        theme={menuTheme}
        defaultSelectedKeys={selectedKey}
        items={menuItems}
        onClick={onMenuSelect}
        switchLabel={switchLabel}
        onSwitchClick={onSwitchClick}
        switchLabelColor={switchLabelColor}
        logoDimensions={logoDimensions}
        menuSearchBarState={menuSearchBarState}
        menuSearchIconState={menuSearchIconState}
        switchLabelState={switchLabelState}
        setCollapsed={setCollapsed}
        leftLayoutMargin={leftLayoutMargin}
        colorBgContainer={colorBgContainer}
      >
        <MainPage titleOfPage={"Add Currency"} />
      </MainLayout>
    </ConfigProvider>
  );
};

const iconMap = {
  Authorised: <CheckOutlined />,
  Unauthorised: <CloseOutlined />,
  Disabled: <WarningOutlined />,
};

function MainPage(props) {
  const [fieldContent, setFieldContent] = useState(<AddSYA1300Form />);
  const navigate = useNavigate();

  return (
    <div style={{ marginBottom: 50 }}>
      <ContentTop titleOfPage={"Add Currency"}>
        <BreadcrumbItem>
          <a href="/dashboard">Home</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <a href="/sya1300">Currency</a>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Text>Add Currency</Text>
        </BreadcrumbItem>
      </ContentTop>
      <div>{fieldContent}</div>
      <Row gutter={16}></Row>
    </div>
  );
}

const RenderedFields = ({ fields, remove, inputName, formValues }) => {
  return (
    <>
      {fields.map(({ key, name, ...restField }) => (
        <Space
          key={key}
          style={{
            display: "flex",
            marginBottom: 8,
          }}
          align="baseline"
        >
          <Form.Item {...restField} name={[name, "inputedCurrency"]}>
            <Input disabled style={{ width: "30vh" }} defaultValue={formValues.currency} />
          </Form.Item>

          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => remove(name)}
            okText="OK"
            cancelText="Cancel"
            okButtonProps={{
              style: {
                backgroundColor: "#92428B",
                color: "white",
                height: "15%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
            cancelButtonProps={{
              style: {
                height: "15%",
                backgroundColor: "white",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              },
            }}
          >
            <CloseCircleFilled
              height={2}
              width={2}
              style={{ color: "#92428B", fontSize: "25px", fontWeight: "bolder" }}
            />
          </Popconfirm>
        </Space>
      ))}
    </>
  );
};

function AddSYA1300Form() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);

  const [form] = useForm();

  const onFinishForm = (values) => {
    console.log(values);
    setFormData(values);
  };
  const handleValuesChange = (changedValues, allValues) => {
    setFormData(allValues);
  };

  function onCancel() {
    navigate("/sya1300", { replace: false });
  }

  return (
    <Form
      layout="vertical"
      style={{ paddingTop: 20 }}
      onFinish={onFinishForm}
      form={form}
      initialValues={formData}
      onValuesChange={handleValuesChange}
    >
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Card
          style={{
            marginBottom: "2%",
            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          }}
        >
          <Form.Item
            name={"currency"}
            rules={[
              {
                required: true,
                message: "Required field",
              },
            ]}
          >
            <Input style={{ width: "30vh" }} placeholder="Add Currency" />
          </Form.Item>

          <Form.List name="newCurrency">
            {(fields, { add, remove }) => (
              <>
                <Button
                  onClick={() => add()}
                  type="primary"
                  icon={<PlusOutlined />}
                  style={{
                    backgroundColor: "#92428B",
                    color: "white",
                    width: "15vh",
                    marginBottom: 20,
                  }}
                >
                  Add
                </Button>
                <RenderedFields
                  fields={fields}
                  add={add}
                  remove={remove}
                  inputName={"newCurrency"}
                  formValues={formData}
                />
              </>
            )}
          </Form.List>
        </Card>

        <Form.Item>
          <Row>
            <CustomButton
              content="Submit"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={onCancel}
            />
          </Row>
        </Form.Item>
      </Card>
    </Form>
  );
}

export default AddSYA1300;
